import { __decorate } from "tslib";
import tableHeader from '@blade-sxp/task-management/components/table-header.vue';
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { getStatisticsList, deleteTask, zoneList } from '@blade-sxp/task-management/api/statistics/index';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    multipleTable;
    // @Prop() readonly keyword?: keyword;
    condition;
    colors = colors;
    multipleSelection = [];
    multipleLength = 0;
    zoneId = '';
    showColor = false;
    dateRange = ['', ''];
    ellipsisName(str) {
        return str?.length > 15 ? str.slice(0, 15) + '...' : str;
    }
    form;
    formChange(val) {
        this.getTaskList();
    }
    onConditionUpdate(condition) {
        this.pagination.page = 1;
        this.getTaskList();
    }
    taskStatus = '';
    filterStatus = [];
    filterTaskStatus = [];
    filterArea = [];
    loading = false;
    taskList = [];
    total = 0;
    pageOrderList = [
        {
            orderField: 'create_time',
            orderType: 'DESC',
        },
    ];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    initI18n() {
        this.filterArea = [];
        this.filterTaskStatus = [
            { text: String(this.$t('effect')), value: 'ENABLE' },
            { text: String(this.$t('noEffective')), value: 'DISABLE' },
            { text: String(this.$t('abnormal')), value: 'ERROR' },
        ];
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getTaskList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTaskList();
    }
    getTaskList() {
        this.loading = true;
        if (!this.condition.dateRange || this.condition.dateRange?.length === 0) {
            this.dateRange = ['', ''];
        }
        else {
            this.dateRange = this.condition.dateRange;
        }
        const taskListByPageRequest = {
            taskTypes: ['CROWD_STATISTIC'],
            page: this.pagination.page,
            size: this.pagination.size,
            taskStatus: this.taskStatus,
            dateEnd: this.dateRange[1],
            dateStart: this.dateRange[0],
            pageOrderList: this.pageOrderList,
            deviceId: Number(this.condition.device),
            keyword: this.condition.keyword,
            zoneId: this.zoneId,
        };
        getStatisticsList({ ...taskListByPageRequest })
            .then((res) => {
            this.total = res.total;
            this.taskList = res.list ?? [];
            const total = res.total;
            this.pagination.total = total;
        })
            .finally(() => {
            this.loading = false;
            this.$refs.popover.showPopper = false;
        });
    }
    getzoneList() {
        let param = {
            externalBizFrom: '',
            keywords: '',
        };
        zoneList(param).then((res) => {
            if (res.constructor === Array) {
                for (let i in res) {
                    if (res[i].children.length !== 0) {
                        let obj = {
                            text: '',
                            value: 0,
                        };
                        obj.text = res[i].name;
                        obj.value = res[i].id;
                        this.filterArea.push(obj);
                        for (let j in res[i].children) {
                            let objChildren = {
                                text: '',
                                value: 0,
                            };
                            objChildren.text = res[i].children[j].name;
                            objChildren.value = res[i].children[j].id;
                            this.filterArea.push(objChildren);
                        }
                    }
                }
            }
            if (res.constructor === Object) {
                if (res.children.length !== 0) {
                    let obj = {
                        text: '',
                        value: 0,
                    };
                    obj.text = res.name;
                    obj.value = res.id;
                    this.filterArea.push(obj);
                    for (let j in res.children) {
                        let objChildren = {
                            text: '',
                            value: 0,
                        };
                        objChildren.text = res.children[j].name;
                        objChildren.value = res.children[j].id;
                        this.filterArea.push(objChildren);
                    }
                }
            }
        });
    }
    sortChange(order) {
        if (order.order === 'ascending') {
            this.pageOrderList[0].orderType = 'ASC';
        }
        else {
            this.pageOrderList[0].orderType = 'DESC';
        }
        this.getTaskList();
    }
    filterDeviceNameTag(value, row) {
        // return row.deviceName === value;
    }
    filterTaskArea(value, row, column) {
        return row.zoneId === value;
    }
    filterTaskStatusTag(value, row) {
        // return row.status === value;
        // console.log(value);
    }
    handleSelectionChange(val) {
        this.multipleSelection = val;
        this.multipleLength = this.multipleSelection.length;
    }
    /**
     *@Description: 删除任务
     *@Date: 2022-01-17 10:08:01
     */
    handleDelete(e) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('delete')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteTask(e.id)
                        .then((res) => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.getTaskList();
                    })
                        .catch((err) => {
                        this.$message({ message: err, type: 'error' });
                    });
                }
            },
        });
    }
    filterChange(e) {
        if (e.taskStatus.length > 0) {
            this.taskStatus = e.taskStatus[0];
        }
        else {
            this.taskStatus = '';
        }
        this.pagination.page = 1;
        this.getTaskList();
    }
    /**
     *@Description: 编辑任务
     *@Date: 2022-01-17 10:24:22
     */
    handleEdit(id) {
        this.$router.push({ path: '/tasklist/createtask', query: { id: String(id), type: 'edit' } });
    }
    CheckedKeys(e) {
        this.zoneId = e;
        this.pagination.page = 1;
        this.getTaskList();
    }
    nodeClick(e) {
        if (e) {
            this.showColor = true;
        }
        else {
            this.showColor = false;
        }
    }
    mounted() {
        this.getTaskList();
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "condition", void 0);
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Watch('form', { deep: true })
], default_1.prototype, "formChange", null);
__decorate([
    Watch('condition', { deep: true })
], default_1.prototype, "onConditionUpdate", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'population-statistics',
        i18n: {
            messages: {
                zh: {
                    area: '所属区域',
                    newTask: '新建任务',
                    copyTask: '复制任务',
                    task: '任务',
                    choose: '请选择',
                    queueNumber: '排队人物',
                    queueTime: '排队时间',
                    total: '总共 {msg} 条',
                    alertType: '警告类型',
                    effect: '进行中',
                    noEffective: '已停用',
                    abnormal: '异常',
                    deletedSuccessfully: '删除成功',
                    deleteEnter: '该任务正在执行中，请暂停任务后再次尝试删除任务操作',
                    delete: '确定删除这个任务吗？',
                    creationTime: '创建时间',
                    creator: '创建人',
                },
                'en-us': {
                    area: 'Area',
                    newTask: 'New Task',
                    copyTask: 'Copy Task',
                    task: 'Task',
                    choose: 'select',
                    queueNumber: 'Queue Number',
                    queueTime: 'Queue Time',
                    total: 'Total {msg} Items',
                    alertType: 'Aler Type',
                    effect: 'Running',
                    noEffective: 'Disabled',
                    abnormal: 'Abnormal',
                    deletedSuccessfully: 'Deleted successfully',
                    deleteEnter: 'The task is in progress, please pause the task and try to delete the task again',
                    delete: 'Are you sure to delete this task?',
                    creationTime: 'Creation Time',
                    creator: 'Creator',
                },
            },
        },
        components: { tableHeader },
    })
], default_1);
export default default_1;
